import { Locale, type LocalizedString } from "./Locale.js";
import { SolutionGroup } from "./SolutionGroup.js";

interface SolutionGroupTexts {
	heading: LocalizedString;
	description1: LocalizedString;
	ctaLabel: LocalizedString;
}

export const solutionGroupTexts: Record<SolutionGroup, SolutionGroupTexts> = {
	[SolutionGroup.ByIndustry]: {
		heading: {
			[Locale.cs]: "Jsme odborníci na automatizaci skladů s širokým portfoliem služeb v oblasti distribuce",
			[Locale.en]: "We are experts in warehouse automation with a wide portfolio of distribution services",
		},
		description1: {
			[Locale.cs]:
				"V LogTechu si uvědomujeme specifické výzvy každého odvětví. Díky bohatým zkušenostem můžeme vyvíjet řešení pro tyto specifické požadavky a vzájemně propojovat nejvhodnější strategie a řešení pro dané odvětví.",
			[Locale.en]:
				"At LogTech, we understand the specific challenges of each industry. Thanks to our extensive experience, we can develop solutions for these specific requirements and interconnect the most suitable strategies and solutions for the given industry.",
		},
		ctaLabel: {
			[Locale.cs]: "Spojte se s experty pro váš obor",
			[Locale.en]: "Connect with experts for your industry",
		},
	},
	[SolutionGroup.ByTechnology]: {
		heading: {
			[Locale.cs]: "Vybíráme technologie, které jedinečným způsobem splňují vaše provozní požadavky",
			[Locale.en]: "We select technologies that uniquely meet your operational requirements",
		},
		description1: {
			[Locale.cs]:
				"Identifikujeme a vybíráme technologie, které jedinečným způsobem splňují vaše provozní požadavky. Výsledkem je komplexní a flexibilní řešení, které přináší slibované výkony.",
			[Locale.en]:
				"We identify and select technologies that uniquely meet your operational requirements. The result is a comprehensive and flexible solution that delivers the expected performance.",
		},
		ctaLabel: {
			[Locale.cs]: "Konzultujte technologii s naším týmem",
			[Locale.en]: "Consult technology with our team",
		},
	},
	[SolutionGroup.ByDesignation]: {
		heading: {
			[Locale.cs]: "Řešení podle konkrétního určení pro maximální efektivitu vaší logistiky",
			[Locale.en]: "Solutions by specific designation for maximum logistics efficiency",
		},
		description1: {
			[Locale.cs]: "Ať už vaše firma působí v jakémkoliv odvětví, naše řešení zlepšují výkon vaší logistiky již dnes.",
			[Locale.en]:
				"No matter what industry your company operates in, our solutions improve the performance of your logistics today.",
		},
		ctaLabel: {
			[Locale.cs]: "Najděte řešení pro váš provoz",
			[Locale.en]: "Find the solution for your operation",
		},
	},
	[SolutionGroup.ByProduct]: {
		heading: {
			[Locale.cs]: "Specifická produktová řešení pro moderní distribuci a logistiku",
			[Locale.en]: "Specific product solutions for modern distribution and logistics",
		},
		description1: {
			[Locale.cs]: "Vyberte řešení podle konkrétního produktu, který nejlépe odpovídá vašim potřebám.",
			[Locale.en]: "Select a solution based on the specific product that best fits your needs.",
		},
		ctaLabel: {
			[Locale.cs]: "Poraďte se s naším týmem",
			[Locale.en]: "Consult with our team",
		},
	},
};
